import React, { Component, Fragment } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import {
  SEPTA_DailyTrackInspectionReportSchema,
  SEPTA_DailyTrackInspectionReportSectionSchemas,
} from "./SEPTA_DailyTrackInspectionReportSchema";
import { Col, Row } from "reactstrap";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import { SignatureImageImproved } from "../../utils/SignatureImage";
import { dataFormatters } from "../../../../utils/dataFormatters";

const RenderNoResultsWatermark = ({ text }) => {
  return (
    <div
      style={{
        position: "absolute",
        inset: "48% auto auto 50%",
        width: "fit-content",
        height: "fit-content",
        padding: "20px",
        fontSize: "50px",
        fontWeight: 600,
        transform: "translate(-50%, -50%)",
        color: "rgb(179, 176, 176)",
        textTransform: "capitalize",
      }}
    >
      {text}
    </div>
  );
};

const { genInfo, intervalsInfo, issuesInfo, commentSection, instructions } = SEPTA_DailyTrackInspectionReportSectionSchemas;
const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { location, user, date, weather, inspectionType, inspectionTypeDescription, inspectionIntervals, assetsWithIssues } = reportData;
  let { signatureImage } = props;
  //   let rowsData = reportData && reportData.assets && Array.isArray(reportData.assets) ? reportData.assets : [];

  let data = {
    location: location,
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    weather: weather,
    inspectionType: inspectionType,
    inspectionTypeDescription: inspectionTypeDescription,
    inspectionIntervals: inspectionIntervals,
    assetsWithIssues: assetsWithIssues,
  };

  return (
    <Fragment>
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection title="Line Inspection and Repair Report" {...props} centerTitle={true} fontSizeOverride={"30px"} />
        <ReportInfoSection
          rows={[
            {
              col1: {
                title: "Inspector",
                value: data.user,
              },
              col2: {
                title: "Date",
                value: data.reportDate,
              },
            },
          ]}
        />
        <span className="half-spacer"></span>
        <table className="table-bordered" style={{ width: "100%" }}>
          <ReportTableSectionRenderer section={genInfo} rowsData={[data]} />
        </table>
        <Row>
          <Col md={1}></Col>
          <Col md={10}>
            <table className="table-bordered" style={{ width: "100%" }}>
              <ReportTableSectionRenderer section={intervalsInfo} rowsData={data.inspectionIntervals} />
            </table>
          </Col>
          <Col md={1}></Col>
        </Row>

        <table className="table-bordered" style={{ position: "relative", width: "100%" }}>
          <ReportTableSectionRenderer section={issuesInfo} rowsData={data.assetsWithIssues} />
          {data.assetsWithIssues.length === 0 ? <RenderNoResultsWatermark text={"No Exceptions"} /> : null}
        </table>
        <div>
          <div style={{ width: "70%", display: "inline-block" }}>
            <table className="table-bordered" style={{ width: "100%" }}>
              <ReportTableSectionRenderer section={commentSection} rowsData={[data]} />
            </table>
          </div>
          <div style={{ width: "30%", display: "inline-block", position: "absolute" }}>
            <div style={{ padding: "50px" }}>
              <SignatureImageImproved signatureImage={signatureImage} underline={true} underlineTitle={"Inspector Signature"} />
            </div>
          </div>
        </div>

        <div style={{ fontSize: "15px", border: "1px solid black", padding: "10px", width: "100%" }}>
          {instructions.map((ins) => (
            <div style={{ display: "flex", paddingBottom: "10px" }}>
              <div style={{ minWidth: "150px", width: "150px", fontWeight: 600 }}>{`${ins.col}:`}</div>
              <div>{`${ins.text}`}</div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

const SEPTA_DailyTrackInspectionReport = (props) => {
  const { inspec, usersSignatures, nonFraCode } = props;
  return (
    <ReportView
      {...props}
      reportData={{
        assetsWithIssues: ReportGeneratorUtils.getInspectionAssetsWithForm(
          inspec,
          () => true, // allow all asset Types. do we need this?
          null,
          false,
          true,
          usersSignatures,
          true,
          nonFraCode,
          true,
          ["startMp"],
          ["asc"],
        ),
        location: ReportGeneratorUtils.getInspectionLocation(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
        weather: ReportGeneratorUtils.getInspectionWeather(inspec),
        inspectionType: ReportGeneratorUtils.getInspectionType(inspec),
        inspectionTypeDescription: ReportGeneratorUtils.getInspectionTypeDescription(inspec),
        inspectionIntervals: ReportGeneratorUtils.getInspectionIntervals(inspec, ["start"], ["desc"]),
      }}
    />
  );
};

export default SEPTA_DailyTrackInspectionReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SEPTA/DailyTrackInspectionReport/index.jsx